import { fileSchemaInit } from '../redux/features/file/filesSlice';
import { draftInitialJob } from '../redux/features/job/jobsSlice';
import { draftInitialCompany } from '../redux/features/company/companiesSlice';

const DRAFT_JOB = 'DRAFT_JOB';
const DRAFT_COMPANY = 'DRAFT_COMPANY';
const DRAFT_INVOICE_PLAN = 'DRAFT_INVOICE_PLAN';
const DRAFT_FILE = 'DRAFT_FILE';

export const getDraftJobSession = () => {
  return JSON.parse(localStorage.getItem(DRAFT_JOB));
};

export const saveDraftJobSession = (draftJob) => {
  localStorage.setItem(DRAFT_JOB, JSON.stringify(draftJob));
};

export const getDraftCompanySession = () => {
  return JSON.parse(localStorage.getItem(DRAFT_COMPANY));
};

export const saveDraftCompanySession = (draftCompany) => {
  localStorage.setItem(DRAFT_COMPANY, JSON.stringify(draftCompany));
};

export const getDraftInvoicePlanSession = () => {
  return JSON.parse(localStorage.getItem(DRAFT_INVOICE_PLAN));
};

export const saveDraftInvoicePlanSession = (draftInvoicePlan) => {
  localStorage.setItem(DRAFT_INVOICE_PLAN, JSON.stringify(draftInvoicePlan));
};

export const clearDraftJobSession = () => {
  localStorage.setItem(DRAFT_JOB, JSON.stringify(draftInitialJob));
};

export const getDraftFileSession = () => {
  return JSON.parse(localStorage.getItem(DRAFT_FILE));
};

export const saveDraftFileSession = (draftFile) => {
  localStorage.setItem(DRAFT_FILE, JSON.stringify(draftFile));
};

export const clearDraftFileSession = () => {
  localStorage.setItem(DRAFT_FILE, JSON.stringify(fileSchemaInit));
};

export const clearDraftCompanySession = () => {
  localStorage.setItem(DRAFT_COMPANY, JSON.stringify(draftInitialCompany));
};
